import React, { Component } from "react";
import { connect } from "react-redux";
import PipePdfReport from "./pipesPDF.container";
import { Modal } from "office-ui-fabric-react/lib/components/Modal";
import { DefaultButton } from "office-ui-fabric-react/lib-commonjs";
import { togglePipesPdfModal } from "../../actions/pdf-actions";

class pipePdfReportModal extends Component{
    closeModal = () => {
        this.props.togglePdfModal(false);
    };

    render() {
        const {
            lang,
            content,
            showPipesPdfModal,
            togglePipesPdfModal,
            isMultiBed,
        } = this.props;

        return (
            <Modal
                isBlocking={false}
                titleAriaId="titleId"
                subtitleAriaId="subtitleId"
                isOpen={showPipesPdfModal}
                onDismiss={() => togglePipesPdfModal(false)}
                containerClassName="ms-modalExample-container"
            >
                <div id="subtitleId" className="ms-modalExample-body">
                    <div className="ms-Grid" dir="rtl">
                        <div style={{ textAlign: "right", padding: 0, position: "absolute", right: 0 }}
                             className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <DefaultButton
                                text={content[lang].close}
                                onClick={() => togglePipesPdfModal(false)}
                            />
                        </div>
                    </div>
                    <PipePdfReport/>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => {
    return {
        lang: state.localization.lang,
        content: state.localization.content,
        showPipesPdfModal: state.pdf.showPipesPdfModal,
    };
};

const mapDispatchToProps = {
    togglePipesPdfModal,
};

export default connect(
    mapStateToProps, mapDispatchToProps,
)(pipePdfReportModal);



// WEBPACK FOOTER //
// ./src/components/PipesPDF/pipePdfReportModal.component.js